import styled from 'styled-components';

import { media } from '@utils/styled';

export const GiftCardValuesWrapper = styled.div`
  display: grid;
  grid-row-gap: 2rem;
  margin-bottom: 2rem;

  ${media.from480up`
    grid-template-columns: repeat(2, 1fr);
    ${({ theme }) => theme.getFluidSpacing('grid-gap', 'widthBased', 2)}
    ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'widthBased', 2)}
  `}

  ${media.from880up`
    grid-template-columns: repeat(3, 1fr);
  `}
`;
